export default __webpack_public_path__ + "static/media/logo.73ff4de6.png";